import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Post } from 'src/app/models/post';
import { PostService } from 'src/app/services/blog.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-destaque-blog',
  templateUrl: './destaque-blog.component.html',
  styleUrls: ['./destaque-blog.component.scss']
})
export class DestaqueBlogComponent implements OnInit {

  posts: Post[] = [];

  constructor(private blogService: PostService) { }

  ngOnInit() {
    this.loadPosts();
  }

  async loadPosts() {
    try {
      const posts = await this.blogService.getDestaque();
      this.posts = posts["posts"] as Post[];
    } catch (error) {
      console.error('Erro ao carregar posts:', error);
    }
  }


}
